export const REDUX_COOKIES_UPDATE = Symbol();
export const REDUX_COOKIES_SET = Symbol();
export const REDUX_COOKIES_REMOVE = Symbol();
export function setCookie(name, value, options = {}) {
    return {
        type: REDUX_COOKIES_SET,
        payload: { name, value, options },
    };
}
export function removeCookie(name) {
    return { type: REDUX_COOKIES_REMOVE, payload: name };
}
export function updateCookie(name, value, options = {}) {
    return {
        type: REDUX_COOKIES_UPDATE,
        payload: { name, value, options },
    };
}
;
//# sourceMappingURL=actions.js.map